import { render, staticRenderFns } from "./addChoiceModal.vue?vue&type=template&id=307f2910&scoped=true"
import script from "./addChoiceModal.vue?vue&type=script&lang=js"
export * from "./addChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./addChoiceModal.vue?vue&type=style&index=0&id=307f2910&prod&lang=scss&scoped=true"
import style1 from "./addChoiceModal.vue?vue&type=style&index=1&id=307f2910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307f2910",
  null
  
)

export default component.exports